export default {
  de: {
    users: 'Benutzer',
    agreements: 'Ziele',
    citysettingdefinitions: 'Gemeinde',
    elections: 'Wahlen',
    officials: 'Funktionen',
    reports: 'Berichte',
    services: 'Leistungen',
  },
};
